import * as Utils from "../Utils";
import { adminFetch, buildQueryString } from "./admin_api";
import { formatCurrency, normalizePagination } from "./affiliate_helper";

const getAuthToken = () => localStorage.getItem("adminToken");

const authHeaders = () => ({
  Accept: "application/json",
  "Content-Type": "application/json",
  Authorization: `Bearer ${getAuthToken()}`,
});

const referralDiscountApi = (path, options = {}) =>
  adminFetch(`${Utils.API_URL}v1/admin/referral-discounts${path}`, {
    ...options,
    headers: {
      ...authHeaders(),
      ...(options.headers || {}),
    },
  });

/**
 * POST /api/v1/admin/referral-discounts
 */
export async function createReferralDiscount(payload) {
  return referralDiscountApi("", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

/**
 * GET /api/v1/admin/referral-discounts
 */
export async function getReferralDiscounts(params = {}) {
  return referralDiscountApi(buildQueryString(params), { method: "GET" });
}

/**
 * GET /api/v1/admin/referral-discounts/:id
 */
export async function getReferralDiscountDetails(id) {
  return referralDiscountApi(`/${id}`, { method: "GET" });
}

/**
 * PATCH /api/v1/admin/referral-discounts/:id
 */
export async function updateReferralDiscount(id, payload) {
  return referralDiscountApi(`/${id}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
}

/**
 * DELETE /api/v1/admin/referral-discounts/:id — soft deactivate
 */
export async function deactivateReferralDiscount(id) {
  return referralDiscountApi(`/${id}`, { method: "DELETE" });
}

/**
 * GET /api/v1/admin/referral-discounts/analytics
 */
export async function getReferralDiscountAnalytics() {
  return referralDiscountApi("/analytics", { method: "GET" });
}

export const REFERRAL_DISCOUNT_STATUSES = [
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
];

export const getReferralDiscountStatusBadge = (status) => {
  switch (status) {
    case "active":
      return "success";
    case "inactive":
      return "secondary";
    default:
      return "secondary";
  }
};

export const normalizeReferralDiscountList = (res) => {
  const candidates = [
    res?.data?.items,
    res?.data?.referralDiscounts,
    res?.referralDiscounts,
    res?.data,
  ];
  const list = candidates.find((item) => Array.isArray(item));
  return list || [];
};

export const normalizeReferralDiscountDetail = (res) => {
  if (!res) return null;
  if (res?.data && typeof res.data === "object" && !Array.isArray(res.data)) {
    return res.data;
  }
  return res;
};

export const normalizeReferralDiscountPagination = (res) => normalizePagination(res);

export const normalizeReferralDiscountAnalytics = (res) => {
  const data = res?.data || res || {};
  return {
    summary: data.summary || {
      totalReferrals: 0,
      totalDiscountGiven: 0,
      totalRevenue: 0,
      currency: "INR",
    },
    topAffiliates: Array.isArray(data.topAffiliates) ? data.topAffiliates : [],
    monthlyReports: Array.isArray(data.monthlyReports) ? data.monthlyReports : [],
    discountDistribution: Array.isArray(data.discountDistribution) ? data.discountDistribution : [],
  };
};

export const formatUsageDisplay = (current, max) => {
  const used = Number(current) || 0;
  if (max === null || max === undefined || max === "") {
    return `${used} / ∞`;
  }
  const limit = Number(max);
  if (Number.isNaN(limit)) return `${used}`;
  return `${used} / ${limit}`;
};

export { formatCurrency };
